import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Lazy load all components for better performance
const LandingPage = React.lazy(() => import("../LandingPage/LandingPage"));
const EdgeNexus = React.lazy(() => import("../EdgeNexus/edgeNexus"));
const Team = React.lazy(() => import("../OurTeam/Team"));
const Contact = React.lazy(() => import("../Contact/Contact"));
const Microsoft = React.lazy(() => import("../Microsoft/Microsoft"));
const Blog = React.lazy(() => import("../Blog/Blog"));
const Login = React.lazy(() => import("../Login/Login"));
const ForgotPassword = React.lazy(
  () => import("../ForgotPassword/ForgotPassword"),
);
const ResetPassword = React.lazy(
  () => import("../ResetPassword/ResetPassword"),
);
const AcceptInvitation = React.lazy(
  () => import("../AcceptInvitation/AcceptInvitation"),
);
const UserManagement = React.lazy(
  () => import("../UserManagement/UserManagement"),
);
const MobileApplications = React.lazy(
  () => import("../MobileApplications/MobileApplications"),
);
const AdminDashboard = React.lazy(
  () => import(/* webpackChunkName: "admin" */ "../AdminDashboard/AdminDash"),
);
const SoftwareDev = React.lazy(() => import("../SoftwareDev/SoftwareDev"));
const FiscalSolutions = React.lazy(
  () => import("../FiscalSolutions/FiscalSolutions"),
);
const BlogPostPage = React.lazy(() => import("../BlogPost/Post"));
const SoftwareProducts = React.lazy(
  () => import("../SoftwareProducts/SoftwareProducts"),
);
const PowerPages = React.lazy(() => import("../PowerPages/PowerPages"));
const GSCGuestHouse = React.lazy(() => import("../GSC/GSC"));
const EGRC = React.lazy(() => import("../EGRC/EGRC"));
const OmniMart = React.lazy(() => import("../OmniMart/OmniMart"));
const Unsubscribe = React.lazy(() => import("../Unsubscribe/Unsubscribe"));
// Loading component
const PageLoader = () => (
  <div
    style={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #0e0033 0%, #1a0f47 100%)",
      color: "#64DFDF",
    }}
  >
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "3px solid transparent",
          borderTop: "3px solid #64DFDF",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
          margin: "0 auto 20px",
        }}
      ></div>
      <p>Loading...</p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  </div>
);

const AllRoutes = () => {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route
            path="*"
            element={
              <h1
                className="text-center"
                style={{
                  height: "100vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                }}
              >
                Page not found
              </h1>
            }
          />

          <Route path="/" element={<LandingPage />} />
          <Route path="/admin-login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/accept-invitation" element={<AcceptInvitation />} />
          <Route path="/user-management" element={<UserManagement />} />

          <Route path="edge-nexus" element={<EdgeNexus />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/microsoft-solutions" element={<Microsoft />} />
          <Route path="/blog-posts" element={<Blog />} />
          <Route path="/admin-dash" element={<AdminDashboard />} />
          <Route path="/software-dev" element={<SoftwareDev />} />
          <Route path="/fiscal-services" element={<FiscalSolutions />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />

          {/* <Route path="/software-products" element={<SoftwareProducts />} /> */}
          <Route path="/mobile-apps" element={<MobileApplications />} />
          <Route path="/power-pages" element={<PowerPages />} />
          <Route path="/gsc-guest-house" element={<GSCGuestHouse />} />
          <Route path="/egrc-solutions" element={<EGRC />} />
          <Route path="/omni-mart" element={<OmniMart />} />

          {/* Add more routes as needed */}
        </Routes>
      </Suspense>
    </>
  );
};

export default AllRoutes;
